module.exports = __webpack_public_path__ + "static/media/sample-friends-image.f6589fab.webp";